import React from 'react'
import * as S from '../style'

const Loading = () => {
  return (
    <div>
      <S.RotatingSvg
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 68 69"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M46.299 15.4605C42.0671 12.7267 37.0449 11.4808 32.0259 11.9196C27.0068 12.3583 22.277 14.4568 18.5836 17.8834C14.8901 21.31 12.4436 25.8695 11.6304 30.8416C10.8172 35.8137 11.6837 40.9151 14.0931 45.3398C16.5025 49.7645 20.3173 53.2604 24.9351 55.2753C29.5528 57.2901 34.7102 57.7091 39.5926 56.466C44.475 55.2229 48.8041 52.3885 51.8961 48.4107C54.988 44.4329 56.6665 39.5383 56.6665 34.5001C56.6665 32.9353 57.9351 31.6668 59.4999 31.6668C61.0647 31.6668 62.3332 32.9353 62.3332 34.5001C62.3332 40.7978 60.235 46.9161 56.3701 51.8884C52.5052 56.8606 47.0938 60.4035 40.9908 61.9574C34.8878 63.5113 28.441 62.9876 22.6689 60.4691C16.8967 57.9505 12.1281 53.5806 9.11642 48.0497C6.10472 42.5188 5.02156 36.1421 6.03804 29.927C7.05453 23.7118 10.1127 18.0125 14.7295 13.7292C19.3463 9.44594 25.2586 6.8229 31.5323 6.27443C37.8061 5.72597 44.0839 7.28335 49.3738 10.7006C50.6883 11.5496 51.0655 13.3035 50.2164 14.6179C49.3673 15.9323 47.6135 16.3095 46.299 15.4605Z"
          fill="#6A6977"
        />
      </S.RotatingSvg>
    </div>
  )
}

export default Loading
